import React, { Fragment } from "react";
import BrowserBezel from "components/BrowserBezel";
import CheckoutPreview from "components/CheckoutPreview";
import CheckoutPreviewLoader from "components/CheckoutPreview/Loader";
import ShortLinkFulfillmentDetails from "components/ShortLinkFulfillmentDetails";
import CodeLinkPreview from "components/CodeLinkPreview";
import { IMAGE_DIMENSIONS } from "components/CheckoutPreview";
import {
  isSetupShortLink,
  useShortLinkCheckoutResourceUrl
} from "utils/shortLink";
import classnames from "classnames";
import { useCtxReferences } from "utils/selectors";
import get from "lodash/get";

const CollapseImageRow = ({ collapseImages, children }) => (
  <div className="w-100 flex flex-row">
    {!collapseImages ? <div style={IMAGE_DIMENSIONS}></div> : null}
    <div
      className={classnames("w-100 bt hairline-1", {
        ml3: !collapseImages
      })}
    >
      {children}
    </div>
  </div>
);

const ShortLinkBrowserPreview = ({
  shortLink,
  preview,
  hideCode,
  hideUrl,
  loading
}) => {
  const { merchantAccount } = useCtxReferences();
  const businessIcon = get(merchantAccount, "profile.businessIcon");

  const resourceUrl = useShortLinkCheckoutResourceUrl(shortLink.short_id);

  const isSetup = isSetupShortLink(shortLink);
  const { collapseImages } = preview;
  const liveUrl =
    shortLink && shortLink.short_id && !hideUrl ? resourceUrl : "";

  const codePreviewProps = {
    href: liveUrl,
    size: 44,
    shortId: shortLink.short_id,
    name: shortLink.title,
    image: businessIcon,
    customClasses: {
      container: "flex flex-column flex-row-ns justify-between items-center pt3"
    }
  };

  const showLoader =
    loading || (preview.checkout.lineItems.length === 0 && !isSetup);

  return (
    <BrowserBezel href={liveUrl}>
      <div className="pa3">
        {showLoader ? (
          <CheckoutPreviewLoader />
        ) : (
          <Fragment>
            <div className="w-100">
              <CheckoutPreview
                collapseImages={collapseImages}
                {...preview.checkout}
              />
              <CollapseImageRow collapseImages={collapseImages}>
                <ShortLinkFulfillmentDetails data={shortLink} />
              </CollapseImageRow>
            </div>
            {!hideCode && (
              <div className="pt3">
                <CollapseImageRow collapseImages={collapseImages}>
                  <CodeLinkPreview {...codePreviewProps} />
                </CollapseImageRow>
              </div>
            )}
          </Fragment>
        )}
      </div>
    </BrowserBezel>
  );
};

export default ShortLinkBrowserPreview;
